import React from 'react';

export const GlassTooltip = ({
  children,
  content,
  className = '',
}) => {
  return (
    <span className={`glass-tooltip ${className}`}>
      {children}
      <span className="tooltip-content">{content}</span>
    </span>
  );
};